import {
  Avatar,
  Box,
  Card,
  Container,
  Grid,
  Rating,
  Typography
} from '@mui/material';

interface Testimonial {
  name: string;
  review: string; // review is text, not number
}

interface TestimonialsProps {
  testimonials: Testimonial[];
}

const Testimonials = ({ testimonials }: TestimonialsProps) => {
  return (
    <Box py={5} bgcolor="#ffffff">
      <Container maxWidth="lg">
        <Typography variant="h4" fontWeight={700} textAlign="center" mb={2}>
          What Our Users Say
        </Typography>

        <Grid container spacing={4}>
          {testimonials.map((t, i) => (
            <Grid item xs={12} md={4} key={i}>
              <Card sx={{ p: 4, height: '100%', borderRadius: 2 }}>
                {/* Row: Avatar + Name */}
                <Box display="flex" alignItems="center" gap={2} mb={1}>
                  <Avatar sx={{ bgcolor: 'primary.main' }}>{t.name[0]}</Avatar>

                  <Typography variant="h6" fontWeight={600}>
                    {t.name}
                  </Typography>
                </Box>

                {/* ⭐⭐⭐⭐⭐ Rating */}
                <Rating
                  value={5}
                  readOnly
                  size="small"
                  sx={{ color: '#f5b400', mb: 1 }}
                />

                <Typography variant="body2" color="text.secondary">
                  "{t.review}"
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Testimonials;